/* unplugin-vue-components disabled */import { render } from "./CColumn1.vue?vue&type=template&id=688ef1fc&scoped=true&ts=true"
import script from "./CColumn1.vue?vue&type=script&lang=ts"
export * from "./CColumn1.vue?vue&type=script&lang=ts"

import "./CColumn1.vue?vue&type=style&index=0&id=688ef1fc&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688ef1fc"]])

export default __exports__